
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase/payment/wallet",
      function () {
        return require("private-next-pages/quick-purchase/payment/wallet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quick-purchase/payment/wallet"])
      });
    }
  